import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import {
  KeyboardArrowLeft,
} from '@material-ui/icons';
import {
  inject, observer,
} from 'mobx-react';
import {
  WithSnackbarProps,
} from 'notistack';
import React, {
  Component,
} from 'react';
import {
  RouteComponentProps, withRouter,
} from 'react-router';
import * as Yup from 'yup';
import {
  images,
} from '../../assets/image';
import {
  FormField,
} from '../../components/GeneralCRUDComponent/FormFields/formFields';
import GeneralFormComponent from '../../components/GeneralCRUDComponent/GeneralFormComponent/GeneralFormComponent';
import SnackBarComponent from '../../components/SnackBarComponent/SnackBarComponent';
import Spinner from '../../components/Spinner';
import {
  countriesIsoCodes,
} from '../../constants/countries';
import {
  getDropdownLanguagesList, languageCodes,
} from '../../constants/languages';
import {
  translate,
} from '../../helperFunctions/translation';
import {
  IAcademiesStore,
} from '../../mobx-store/storeInterfaces/academiesInterface';
import {
  ICountry,
} from '../../mobx-store/storeInterfaces/authInterface';
import {
  IBranchStore,
} from '../../mobx-store/storeInterfaces/branchInterface';
import {
  INewsCategoryStore,
} from '../../mobx-store/storeInterfaces/newsCategoryInterface';
import {
  CountryStore,
} from '../../mobx-store/stores/countryStore';
import classes from './addEditAcademy.module.scss';

interface IProps extends WithSnackbarProps {
  academiesStore: IAcademiesStore;
  branchStore: IBranchStore;
  countryStore: CountryStore;
  newsCategoryStore: INewsCategoryStore;
  match: any;
  history: any;
}

interface IState {
  formFields: FormField[];
  branches: any[];
  categories: any[];
  loadingAcademy: boolean;
  loadingBranches: boolean;
  loadingManagedCountries: boolean;
  loadingCategories: boolean;
  loadingSports: boolean;
  title: string;
  desc: string;
  image: string;
  processing: boolean;
  selectedLang: string;
}

@inject('academiesStore')
@inject('branchStore')
@inject('countryStore')
@inject('newsCategoryStore')
@observer
class AddEditAcademy extends Component<IProps & RouteComponentProps, IState> {
  isNew = false;

  isEgypt = false;

  academyId = -1;

  pageTitle = '';

  lastHistory = -1;

  academyFormTitle = '';

  academySchema: any;

  submitButton: any;

  cancelButton: any;

  initGallery: { imageUrl: string; key: number }[] = [];

  dropdownLanguages: {
    langList: {langCode: string; langValue: string} [];
    selectedLang: string;
    label: string;
    onChange(langCode: string): any;
  } | null = null;

  constructor(props: IProps & RouteComponentProps) {
    super(props);
    this.initializeComponent(props);
  }

  async componentDidMount() {
    const {
      countryStore,
      branchStore,
      newsCategoryStore,
      academiesStore,
    } = this.props;

    await countryStore.getUserManagedCountries();
    if (countryStore.managedCountries.some((country: ICountry) => country.isoCode === countriesIsoCodes.egypt)) {
      this.isEgypt = true;
    }

    this.initState(false);
    this.submitButton = this.getSubmitButton();
    branchStore.getBranches(countryStore.managedCountries)
      .then(() => {
        this.updateStateWithBranchesData();
      }).catch(() => {
        this.setState({
          loadingBranches: false,
        });
      });

    newsCategoryStore.getArticlesCategories(countryStore.managedCountries)
      .then(() => {
        this.updateStateWithCategoriesData();
      }).catch(() => {
        this.setState({
          loadingCategories: false,
        });
      });

      if (this.isEgypt) {
          academiesStore.getSportsWDC()
        .then(() => {
          this.updateStateWithSportsData();
        }).catch(() => {
          this.setState({
            loadingSports: false,
          });
        });
      }
      this.setState({
        loadingManagedCountries: false,
        loadingSports: false,
      });

    if (!this.isNew) {
      academiesStore.getAcademyById(this.academyId, languageCodes.english)
        .then(() => {
          this.setState({
            title: this.props.academiesStore.selectedAcademy.title,
            desc: this.props.academiesStore.selectedAcademy.description,
            image: this.props.academiesStore.selectedAcademy.cardThumbnail[0].imageUrl,
          });
          this.updateStateWithAcademyData();
        }).catch(() => {
          this.setState({
            loadingAcademy: false,
          });
        });
    }
  }

  componentWillReceiveProps(nextProps: IProps & RouteComponentProps) {
    if (this.props.location.pathname !== nextProps.location.pathname) {
      this.lastHistory = -2;
      this.initializeComponent(nextProps, false);
      this.forceUpdate();
      this.setState({
        loadingManagedCountries: false,
      });
      this.props.branchStore.getBranches(this.props.countryStore.managedCountries)
        .then(() => {
          this.updateStateWithBranchesData();
        }).catch(() => {
          this.setState({
            loadingBranches: false,
          });
        });

      this.props.newsCategoryStore.getArticlesCategories(this.props.countryStore.managedCountries)
        .then(() => {
          this.updateStateWithCategoriesData();
        }).catch(() => {
          this.setState({
            loadingCategories: false,
          });
        });

      this.props.academiesStore.getSportsWDC()
        .then(() => {
          this.updateStateWithSportsData();
        }).catch(() => {
          this.setState({
            loadingSports: false,
          });
        });

      if (!this.isNew) {
        this.props.academiesStore.getAcademyById(this.academyId, languageCodes.english)
          .then(() => {
            this.setState({
              title: this.props.academiesStore.selectedAcademy.title,
              desc: this.props.academiesStore.selectedAcademy.description,
              image: this.props.academiesStore.selectedAcademy.cardThumbnail.length > 0
                ? this.props.academiesStore.selectedAcademy.cardThumbnail[0].imageUrl : '',
            });
            this.updateStateWithAcademyData();
          }).catch(() => {
            this.setState({
              loadingAcademy: false,
            });
          });
      }
    }
  }


  getAcademy = (langCode: string) => {
    this.setState({
      loadingAcademy: true,
    });
    Promise.all([this.props.academiesStore.getAcademyById(this.academyId, langCode),
      this.props.branchStore.getBranches(this.props.countryStore.managedCountries, langCode),
      this.props.newsCategoryStore.getArticlesCategories(this.props.countryStore.managedCountries, langCode),
      this.props.academiesStore.getSportsWDC(langCode)])
      .then(() => {
        this.updateStateWithAcademyData();
        this.updateStateWithBranchesData();
        this.updateStateWithCategoriesData();
        this.updateStateWithSportsData();
        this.dropdownLanguages!.selectedLang = langCode;
        this.setState({
          title: this.props.academiesStore.selectedAcademy.title,
          desc: this.props.academiesStore.selectedAcademy.description,
          image: this.props.academiesStore.selectedAcademy.cardThumbnail[0].imageUrl,
          selectedLang: langCode,
        });
      }).catch(() => {
        this.setState({
          loadingAcademy: false,
        });
      });
  };

  handelLanguageChange = (langCode: string) => {
    if (this.isNew) {
      this.setState({
        selectedLang: langCode,
      });
    } else {
      this.getAcademy(langCode);
    }
  };

  getDropdownLanguages = () => {
    if (this.isNew) {
      return null;
    }
    return {
      langList: getDropdownLanguagesList(),
      selectedLang: this.state.selectedLang,
      label: 'Select Languages',
      onChange: this.handelLanguageChange,
    };
  };

  initAcademySchema = () => {
     const schemaShape = {
      title: Yup.string()
        .required('Required'),
      description: Yup.string()
        .required('Required'),
      cardThumbnail: Yup.array()
        .required('Required'),
      backgroundThumbnail: Yup.array(),
      images: Yup.array(),
      isActive: Yup.boolean().default(true),
      AcademyCategories: Yup.number(),
      SportsWDC: Yup.number()
        .required('Required'),
    };
    if (!this.isEgypt) {
      delete schemaShape.SportsWDC;
    }
    this.academySchema = Yup.object().shape(schemaShape);
  };

  getFormFields = (): FormField[] => {
    const formFields: FormField[] = [
      {
        name: 'title',
        label: this.isNew && this.isEgypt ? translate('addAcademyPageFormArabicName', {
        }) : translate('addAcademyPageFormEnglishName', {
        }),
        type: 'text',
        filedType: 'InputField',
      },
      {
        name: 'description',
        label: this.isNew && this.isEgypt ? translate('addAcademyPageFormArabicDescription', {
        }) : translate('addAcademyPageFormEnglishDescription', {
        }),
        type: 'text',
        multiLine: true,
        rowsMax: 3,
        filedType: 'InputField',
      },
      {
        name: 'availableBranches',
        label: translate('addAcademyPageFormAvailableBranches', {
        }),
        selectList: [],
        selectListValue: 'title',
        selectListKey: 'id',
        filedType: 'MultipleSelectField',
      },
      {
        name: 'SportsWDC',
        label: translate('addAcademyPageFormSports', {
        }),
        selectList: [],
        selectListValue: 'title',
        selectListKey: 'academyId',
        filedType: 'DropdownField',
      },
      {
        name: 'AcademyCategories',
        label: translate('addAcademyPageFormAcademyCategories', {
        }),
        selectList: [],
        selectListValue: 'title',
        selectListKey: 'categoryId',
        filedType: 'MultipleSelectField',
      },
      {
        name: 'images',
        label: translate('addAcademyPageFormGallery', {
        }),
        filedType: 'GalleryField',
        accept: 'image/*',
        size: 500,
      },
      {
        name: 'cardThumbnail',
        label: translate('addAcademyPageFormPreviewImage', {
        }),
        filedType: 'GalleryField',
        isLimitToOneImage: true,
        accept: 'image/*',
        size: 500,
      },
      {
        name: 'backgroundThumbnail',
        label: translate('addAcademyPageFormBackgroundImage', {
        }),
        filedType: 'GalleryField',
        isLimitToOneImage: true,
        accept: 'image/*',
        size: 500,
      },
      {
        name: 'isActive',
        label: translate('addAcademyPageFormStatus', {
        }),
        filedType: 'ToggleButtonField',
        activeLabel: translate('addAcademyPageFormStatusActiveLabel', {
        }),
        inactiveLabel: translate('addAcademyPageFormStatusInactiveLabel', {
        }),
        value: true,
      },
    ];
    if (this.isEgypt) {
      return formFields;
    } else {
      return formFields.filter((formField: FormField) => {
        return formField.name !== 'SportsWDC';
      })
    }
  }

  initState = (isConstructor = true) => {
    const initState: IState = {
      selectedLang: languageCodes.english,
      processing: false,
      loadingAcademy: !this.isNew,
      loadingBranches: true,
      loadingManagedCountries: true,
      loadingSports: true,
      loadingCategories: true,
      branches: [],
      categories: [],
      formFields: this.getFormFields(),
      title: '',
      desc: '',
      image: '',
    };
    if (isConstructor) {
      this.state = initState;
    } else {
      this.setState(initState);
    }
  };

  onChangeValues = (key: any, value: any) => {
    if (key === 'title') {
      this.setState({
        title: value,
      });
    }
    if (key === 'description') {
      this.setState({
        desc: value,
      });
    }
    if (key === 'cardThumbnail') {
      this.setState({
        image: value.length > 0 ? value[0].preview : '',
      });
    }
  };

  handleSubmit = async (values: any) => {
    const {
      academiesStore,
      history,
      countryStore,
    } = this.props;

    values.availableCountries = countryStore.managedCountries.map((country: ICountry) => country.isoCode);

    if (!values.SportsWDC && this.isEgypt) {
      this.setState({processing: false});
      SnackBarComponent.getInstance().openSnackbar(translate('wdcAcademyRequiredErrorMessage', {}), 5000, 'error');
      return;
    } 

    this.setState({
      processing: true,
    });
    if (this.isNew) {
      academiesStore.createAcademy(values)
        .then((academyId) => {
          this.setState({
            processing: false,
          });
          SnackBarComponent.getInstance().openSnackbar(translate('createdMessage', {
          }), 6000, 'success');
          if (this.isEgypt) {
            history.push(`${academyId}/edit`);
          } else {
            history.go(this.lastHistory);
          }
        }).catch((error) => {
          this.setState({
            processing: false,
          });
          SnackBarComponent.getInstance().openSnackbar(translate('errorMessage', {
          }), 4000, 'error');
        });
    } else {
      academiesStore.updateAcademy(values, this.academyId, this.initGallery, this.state.selectedLang).then(() => {
        this.setState({
          processing: false,
        });
        SnackBarComponent.getInstance().openSnackbar(translate('updatedMessage', {
        }), 6000, 'success');
        history.go(this.lastHistory);
      });
    }
  };

  navigateBack = (academyId: number) => {
    this.props.history.goBack();
  };

  getSubmitButton = () => ({
    title: (this.isNew && this.isEgypt ? 'To Next Language' : 'Save Changes'),
    onSubmit: this.handleSubmit,
  });

  getCancelButton = () => ({
    title: 'Cancel',
    onCancel: this.navigateBack,
  });

  updateStateWithAcademyData = () => {
    const formFieldsWithData = [];
    for (const field of this.state.formFields) {
      formFieldsWithData.push({
        ...field, value: this.props.academiesStore.selectedAcademy[field.name],
      });
    }
    this.initGallery = Object.assign([], this.props.academiesStore.selectedAcademy.images);
    this.setState({
      formFields: formFieldsWithData, loadingAcademy: false,
    });
  };

  updateStateWithSportsData = () => {
    const formFieldsWithData = [];
    for (const field of this.state.formFields) {
      if (field.name === 'SportsWDC') {
        formFieldsWithData.push({
          ...field, selectList: this.props.academiesStore.wdcSportsList,
        });
      } else {
        formFieldsWithData.push(field);
      }
    }
    this.setState({
      formFields: formFieldsWithData, loadingSports: false,
    });
  };

  updateStateWithBranchesData = () => {
    const formFieldsWithData = [];
    for (const field of this.state.formFields) {
      if (field.name === 'availableBranches') {
        formFieldsWithData.push({
          ...field, selectList: this.props.branchStore.branchesList,
        });
      } else {
        formFieldsWithData.push(field);
      }
    }
    this.setState({
      formFields: formFieldsWithData, loadingBranches: false,
    });
  };

  updateStateWithCategoriesData = () => {
    const formFieldsWithData = [];
    for (const field of this.state.formFields) {
      if (field.name === 'AcademyCategories') {
        formFieldsWithData.push(
          {
            ...field, selectList: this.props.newsCategoryStore.categoriesList,
          },
        );
      } else {
        formFieldsWithData.push(field);
      }
    }
    this.setState({
      formFields: formFieldsWithData, loadingCategories: false,
    });
  };

  initializeComponent(props: IProps & RouteComponentProps, isConstructor = true) {
    if (props.match.params.id) {
      this.isNew = false;
      this.academyId = props.match.params.id;
      this.pageTitle = translate('editAcademyPageTitle', {
      });
    } else {
      this.isNew = true;
      this.pageTitle = translate('addAcademyPageTitle', {
      });
    }
    this.initAcademySchema();
    this.initState(isConstructor);
    this.submitButton = this.getSubmitButton();
    this.cancelButton = this.getCancelButton();
    this.academyFormTitle = translate('addAcademyPageFormTitle', {
    });
    this.dropdownLanguages = this.getDropdownLanguages();
  }

  render() {
    return (
      <div className={classes.container}>
        <div className={classes.header}>
          <IconButton
            className={classes.backButton}
            onClick={() => this.props.history.goBack()}
            aria-label="Back"
          >
            <KeyboardArrowLeft />
          </IconButton>
          <Typography className={classes.title} variant="h6" gutterBottom>
            {this.pageTitle}
          </Typography>
        </div>
        <div className={classes.container}>
          <div className={classes.image}>
            <div
              style={{
                backgroundImage: `url(${this.state.image ? this.state.image : images.placeHolder})`,
                backgroundSize: 'cover',
                alignItems: 'flex-start',
                justifyContent: 'flex-end',
                width: 300,
                height: 120,
              }}
            >
              <div className={classes.overlay}>
                <p className={classes.title}>{this.state.title}</p>
                <p className={classes.subTitle}>{this.state.desc}</p>
              </div>
            </div>
          </div>
          <div className={classes.containerBottom}>
            <div className={classes.loggedIndiv}>
              <div>
                <img src={images.info} className={classes.info} />
              </div>
              <img src={images.rectangle} className={classes.seprator} />
              <div className={classes.calendarTouchable}>
                <img src={images.calendar} className={classes.calendar} />
              </div>
            </div>
          </div>
        </div>
        <div className={classes.content}>
          {
            this.state.loadingAcademy || this.state.loadingBranches || this.state.loadingSports || this.state.loadingManagedCountries
              ? <Spinner />
              : (
                <GeneralFormComponent
                  dropdownLanguages={this.isEgypt ? this.dropdownLanguages : null}
                  formTitle={this.academyFormTitle}
                  fields={this.state.formFields}
                  formSchema={this.academySchema}
                  onChangeValues={(key: any, value: any) => this.onChangeValues(key, value)}
                  submitButton={this.submitButton}
                  cancelButton={this.cancelButton}
                  processing={this.state.processing}
                />
              )
          }
        </div>
      </div>
    );
  }
}

export default withRouter(AddEditAcademy);
